import React from 'react'

import classes from './Footer.scss'

import Button from '../../../../UI/Button/Button'
import { withTranslate } from 'react-redux-multilingual'

const footer = ({ onSave, onHide, saveDisabled, translate }) => {
  return (
    <div className={classes.ButtonGroup}>
      <span className={classes.Button}>
        <Button color={'primary'} clicked={onSave} disabled={saveDisabled}>
          {translate('save')}
        </Button>
      </span>
      <span className={classes.Button}>
        <Button color={'default'} clicked={onHide}>
          {translate('cancel')}
        </Button>
      </span>
    </div>
  )
}

export default withTranslate(footer)
